import { inject, Injectable } from "@angular/core";
import { DownloadHeatmapsGQL, DownloadHeatmapsMutation, GetHeatMapGQL, GetHeatMapQuery, GetHeatMapRiskGQL, GetHeatMapRiskQuery, GetHeatMapUnificataGQL, GetHeatMapUnificataQuery } from "../../../graphql/generated";
import { map, Observable } from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class HeatmapService {
    private readonly GetHeatMapUnificataGQL: GetHeatMapUnificataGQL = inject(GetHeatMapUnificataGQL);
    private readonly GetHeatMapGQL: GetHeatMapGQL = inject(GetHeatMapGQL);
    private readonly GetHeatMapRiskGQL: GetHeatMapRiskGQL = inject(GetHeatMapRiskGQL);
    private readonly DownloadHeatMapsGQL: DownloadHeatmapsGQL = inject(DownloadHeatmapsGQL);

    getHeatmapUnificata(legalEntityIds: string[], campaignId: string | null, organizationalUnit: string[], businessUnit: string[]): Observable<GetHeatMapUnificataQuery['heatMapResultOverall']> {
        return this.GetHeatMapUnificataGQL.fetch(
            { legalEntityIds, campaignId, businessUnit, organizationalUnit },
            { fetchPolicy: "no-cache" }
        ).pipe(map(result => result.data.heatMapResultOverall));
    }


    getHeatmap(legalEntityIds: string[], campaignId: string | null, organizationalUnit: string[], businessUnit: string[]): Observable<GetHeatMapQuery['processHeatMaps']> {
        return this.GetHeatMapGQL.fetch(
            { legalEntityIds, campaignId, businessUnit, organizationalUnit },
            { fetchPolicy: "no-cache" }
        ).pipe(map(result => result.data.processHeatMaps));
    }

    downaloadHeatmaps(
        campaignId: string,
        legalEntityIds: string[],
        organizationalUnit: string[],
        businessUnit: string[],
        timeZone: string
    ): Observable<DownloadHeatmapsMutation['downloadHeatMap']> {
        return this.DownloadHeatMapsGQL.mutate(
            { campaignId, legalEntityIds, organizationalUnit, businessUnit, timeZone },
            { fetchPolicy: 'no-cache' }).pipe(
                map(res => (res.data?.downloadHeatMap)
                ))
    }

    getHeatmapRisk(legalEntityIds: string[], campaignId: string | null, organizationalUnit: string[], businessUnit: string[]): Observable<GetHeatMapRiskQuery['riskHeatMaps']> {
        return this.GetHeatMapRiskGQL.fetch(
            { legalEntityIds, campaignId, businessUnit, organizationalUnit },
            { fetchPolicy: "no-cache" }
        ).pipe(map(result => result.data.riskHeatMaps));
    }
}